import React from 'react';
import { Chip, Box } from '@mui/material';
import { getCurrentEnvironment, getCurrentConfig } from '../config/environments';
import { isElectron, getPlatform } from '../utils/electron';

const EnvironmentIndicator: React.FC = () => {
  const environment = getCurrentEnvironment();
  const config = getCurrentConfig();
  const platform = getPlatform();

  const getEnvironmentColor = (env: string) => {
    switch (env) {
      case 'dev':
        return 'success';
      case 'demo':
        return 'warning';
      case 'prod':
        return 'error';
      default:
        return 'default';
    }
  };

  const getEnvironmentIcon = (env: string) => {
    switch (env) {
      case 'dev':
        return '🔧';
      case 'demo':
        return '🧪';
      case 'prod':
        return '🚀';
      default:
        return '❓';
    }
  };

  const getPlatformIcon = () => {
    return isElectron() ? '🖥️' : '🌐';
  };

  // Only show in dev and demo
  if (environment === 'prod') {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 8,
        right: 8,
        zIndex: 9999,
        pointerEvents: 'none',
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
      }}
    >
      <Chip
        icon={<span>{getEnvironmentIcon(environment)}</span>}
        label={`${config.name} (${environment})`}
        color={getEnvironmentColor(environment) as any}
        size="small"
        sx={{
          fontWeight: 'bold',
          fontSize: '0.75rem',
          '& .MuiChip-icon': {
            fontSize: '1rem',
          },
        }}
      />
      <Chip
        icon={<span>{getPlatformIcon()}</span>}
        label={platform === 'electron' ? 'Desktop App' : 'Web App'}
        color="info"
        size="small"
        sx={{
          fontWeight: 'bold',
          fontSize: '0.75rem',
          '& .MuiChip-icon': {
            fontSize: '1rem',
          },
        }}
      />
    </Box>
  );
};

export default EnvironmentIndicator;
